import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Typography } from '@material-ui/core';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import SCALogo from '~/assets/images/logo.png';
import { Progress } from '~/components';

import { Wrapper, WrapperLog, Logo } from './styles';

export default function AuthLayout({ children }) {
  const loading = useSelector((state) => state.auth.loading);
  const websiteJSON = JSON.parse(sessionStorage.getItem('web'));
  const website = useMemo(
    () => ({
      logo: SCALogo,
      site_name: 'VLI+ Unidata',
    }),
    []
  );

  return (
    <Wrapper>
      <Progress loading={loading} />
      <WrapperLog>
        <img
          src={
            websiteJSON && websiteJSON.logo ? websiteJSON.logo : website.logo
          }
          alt={
            websiteJSON && websiteJSON.site_name
              ? websiteJSON.site_name
              : website.site_name
          }
        />
        {children}
        <Logo>
          {websiteJSON && !isEmpty(websiteJSON.site_name) ? '' : 'unidata'}
        </Logo>
        <Typography class="versao">
          versão:{' '}
          {new Date(process.env.REACT_APP_TIMESTAMP_BUILD * 1000)
            .toISOString()
            .slice(0, 16)
            .replace('T', '.')
            .replace(':', '')
            .replace('-', '')
            .replace('-', '')}{' '}
          build: {process.env.REACT_APP_COMMIT} tag: {process.env.REACT_APP_TAG}
        </Typography>
      </WrapperLog>
    </Wrapper>
  );
}

AuthLayout.propTypes = {
  children: PropTypes.element.isRequired,
};
